type EmptyStateProps = {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
};

export default function EmptyState({
  icon = "ri-search-eye-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="panel flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-2xl text-accent-500">
        <i className={icon}></i>
      </div>
      <h3 className="text-lg font-medium text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 rounded-md bg-primary-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}